<template>
  <div>
    <div class="page-header">
      <h2>自定义页面管理</h2>
      <el-button type="primary" @click="showDialog(false)">新增页面</el-button>
    </div>
    <el-table :data="list" stripe v-loading="loading">
      <el-table-column label="页面标题" prop="title" min-width="200"/>
      <el-table-column label="排序" prop="sort_order" width="80"/>
      <el-table-column label="状态" width="80"><template #default="{row}"><el-switch v-model="row.status" @change="quickUpdate(row,'status')"/></template></el-table-column>
      <el-table-column label="操作" width="180"><template #default="{row}"><el-button size="small" @click="showDialog(true,row)">编辑</el-button><el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button></template></el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <el-dialog v-model="dialogVisible" :title="isEdit?'编辑页面':'新增页面'" width="800px">
      <el-form ref="formRef" :model="form" :rules="{title:[{required:true}]}" label-width="100px">
        <el-form-item label="页面标题" prop="title"><el-input v-model="form.title"/></el-form-item>
        <el-form-item label="页面内容"><RichTextEditor v-model="form.content" /></el-form-item>
      </el-form>
      <template #footer><el-button @click="dialogVisible=false">取消</el-button><el-button type="primary" @click="handleSave">保存</el-button></template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import RichTextEditor from '../../components/RichTextEditor.vue';
import * as api from '../../api/contentManagement';

const list = ref([]);
const loading = ref(false);
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });
const dialogVisible = ref(false);
const isEdit = ref(false);
const formRef = ref(null);

const form = ref({ title: '', content: '' });

const fetchData = async () => {
  loading.value = true;
  try {
    const params = { page: pagination.current_page, per_page: pagination.per_page };
    if (searchQuery.value) params.search = searchQuery.value;
    const r = await api.getCustomPages(params);
    list.value = r.data || [];
    pagination.current_page = r.pagination?.current_page || 1;
    pagination.total = r.pagination?.total || 0;
  } catch {} finally { loading.value = false; }
};

const showDialog = (edit, row) => {
  isEdit.value = edit;
  form.value = row ? { ...row } : { title: '', content: '' };
  dialogVisible.value = true;
};

const quickUpdate = (r, f) => { api.updateCustomPage(r.id, { [f]: r[f] }); };

const handleSave = async () => {
  const valid = await formRef.value.validate().catch(() => false);
  if (!valid) return;
  try {
    if (isEdit.value) await api.updateCustomPage(form.value.id, form.value);
    else await api.createCustomPage(form.value);
    ElMessage.success('保存成功');
    dialogVisible.value = false;
    await fetchData();
  } catch { ElMessage.error('保存失败'); }
};

const handleDelete = (r) => {
  ElMessageBox.confirm('确定删除？', '提示').then(async () => {
    await api.deleteCustomPage(r.id);
    await fetchData();
  }).catch(() => {});
};

onMounted(fetchData);

</script>
<style scoped>
.header-actions { display: flex; gap: 12px; align-items: center; }
</style>
